import React, { Component, Fragment } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'

import RestClient from '../../RestAPI/RestClient'
import AppUrl from '../../RestAPI/AppUrl';

export class VisitorRegistration extends Component {

      visitors(event){
            event.preventDefault();
   let name = document.getElementById("name").value;
      let phone = document.getElementById("phone").value;
      
          let email = document.getElementById("email").value;
       alert(name+'/'+email+'/'+phone);

          let jsonObject ={name:name,phone:phone,email:email }
       
       RestClient.PostRequest(AppUrl.Vvisitor,JSON.stringify(jsonObject)
      ).then(result=>{
        alert(result);
      }).catch(error=>{
        alert("Error");
      })
      
      



  }
 
   


  render() {
    return (
      <Fragment>
        <Container className='mt-5 mb-5'>
            <Row>
                <Col lg={6} md={6} sm={12}>
                <h1>Visitor Registrations</h1>
                <Form >
      <Form.Group className="mb-3" >
        <Form.Label>Your Name</Form.Label>
  
        <Form.Control required id="name" type="text" placeholder="Enter Your Name" />
       
      </Form.Group>

        <Form.Group className="mb-3" >
        <Form.Label>Phone</Form.Label>
        <Form.Control id="phone" type="text" placeholder="Enter your Phone Number" />
       
      </Form.Group>


     

        <Form.Group className="mb-3" >
        <Form.Label>Email address</Form.Label>
        <Form.Control id='email' type="email" placeholder="Enter email" />
        <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text>
      </Form.Group>

      
     
      <Button   onClick={(event) => {
                    const name = document.getElementById("name").value.trim();
                    const phone = document.getElementById("phone").value.trim();
                    const email = document.getElementById("email").value.trim();

                    // manual required check (no reload)
                    if (!name || !phone || !email) {
                      alert("Please fill all required fields.");
                      return;
                    }

                    this.visitors(event);
                  }} variant="primary" >
        Submit
      </Button>
    </Form>


                </Col>
                
            </Row>
        </Container>
      </Fragment>
    )
  }
}

export default VisitorRegistration
